import { type AxiosRequestConfig, httpClient } from '@ahm/api-wrappers-core';
import { apiRoutes } from '../../api-routes';
import type { UpdateStopInfoRequest, UpdateStopInfoResponse } from '../type';

export const verifyStopInfoFn = async (
  orderId: string,
  body: UpdateStopInfoRequest,
  config: AxiosRequestConfig = {}
) => {
  const response = await httpClient.patch<UpdateStopInfoResponse>(
    `${apiRoutes.order.stopInformation(orderId)}?validate_only=true`,
    body,
    config
  );

  return response.data;
};
